export const locationFormatter = (location) => {
   switch (location.toLowerCase()) {
    case "bristol, city of":
        location = "Bristol";
        break;
    case "burnley":
        location = "Lancashire";
        break;
    case "newcastle upon tyne":
        location = "Newcastle";
        break;
    case "nottingham":
        location = "East Midlands";
        break;
    case "leeds":
        location = "Yorkshire";
           break;
    case "northern ireland":
        location = "Northern Ireland";
        break;
    default:
        location
    }
    return location.replace(/^./, location[0].toUpperCase())
}


